<template>
  <div>
      <br>
      <b-button>test</b-button>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
export default {
    components: {
        BButton
    }
}
</script>

<style>

</style>